var tracking = {

	init: function () {

		tracking.trackListViews();
		tracking.trackSelectItemClick();
		tracking.trackingRemoveFromCartClick();
	},

	trackListViews: function () {

		var observer = new IntersectionObserver(observerCallback, {
			rootMargin: "0px 0px 0px 0px"
		});

		var listViewElements = document.querySelectorAll('.js-track-list');

		function observerCallback(entries, observer) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {

					var listDetails = tracking.getListDetails(entry.target);
					var itemsInList = tracking.getItemsFromList(entry.target);
					tracking.trackListView(listDetails, itemsInList);

					observer.unobserve(entry.target);
				}
			});
		};

		for (var i = 0; i < listViewElements.length; i++) {
			observer.observe(listViewElements[i]);
		}
	},

	trackSelectItemClick: function () {
		document.addEventListener('click', function (event) {
			if (event.target.matches('.js-track-product-link')) {
				var productElement = event.target.closest('.js-track-product');
			 var productDetails = tracking.getItemDetails(productElement);
			 var listElement = productElement.closest('.js-track-list');
			 var listDetails = tracking.getListDetails(listElement); 
				tracking.trackSelectItem(listDetails, productDetails);
			}
		}, false);
	},

	trackingRemoveFromCartClick: function () {
		document.addEventListener('click', function (event) {
			if (event.target.matches('.js-track-remove-cart')) {
				var productElement = event.target;
				var productDetails = tracking.getItemDetails(productElement);
				var quantity = productElement.getAttribute('data-product-quantity');
				tracking.trackRemoveFromCart({
					Id: productDetails.item_id,
					DisplayName: productDetails.item_name,
					Price: {
						Price: productDetails.price,
					},
					Quantity: quantity
				});
			}
		}, false);
	},

	trackListView: function (list, items) {
		dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: "view_item_list",
			ecommerce: {
				item_list_id: list.item_list_id,
				item_list_name: list.item_list_name,
				items: items
			}
		});
	},

	trackSelectItem: function (list, item) {
		dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: "select_item",
			ecommerce: {
				item_list_id: list.item_list_id,
				item_list_name: list.item_list_name,
				items: [item]
			}
		});
	},

	getItemDetails: function(product) {
		return {
			item_id: product.getAttribute('data-product-id'),
			item_name: product.getAttribute('data-product-name'),
			price: parseFloat(product.getAttribute('data-product-price'))
		}
	},

	getItemsFromList: function (listElement) {
		var items = [];
		var products = listElement.querySelectorAll('[data-product-id]');
		for (var i = 0; i < products.length; i++) {
			var currentProduct = products[i];
			items.push(tracking.getItemDetails(currentProduct));
		}
		return items;
	},

	getListDetails: function (list) {
		return {
			item_list_id: list.getAttribute('data-list-id'),
			item_list_name: list.getAttribute('data-list-name')
		}
	},

	getListDetailsForProduct: function (product) {
		var list = product.closest('.js-track-list');
		return tracking.getListDetails(list);
	},

	trackAddToCart: function (addToCartResponse) {
		dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: 'add_to_cart',
			ecommerce: {
				value: parseFloat((addToCartResponse.Price.Price * addToCartResponse.Quantity).toFixed(2)),
				currency: 'GBP',
				items: [{
					item_id: addToCartResponse.Id,
					item_name: addToCartResponse.DisplayName,
					price: addToCartResponse.Price.Price,
					quantity: addToCartResponse.Quantity
				}]
			}
		});
	},

	trackRemoveFromCart: function (removeFromCartResponse) {
		dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: 'remove_from_cart',
			ecommerce: {
				value: parseFloat((removeFromCartResponse.Price.Price * removeFromCartResponse.Quantity).toFixed(2)),
				currency: 'GBP',
				items: [{
					item_id: removeFromCartResponse.Id,
					item_name: removeFromCartResponse.DisplayName,
					price: removeFromCartResponse.Price.Price,
					quantity: removeFromCartResponse.Quantity
				}]
			}
		});
	},

	trackAddToWishlist: function (addToWishlistResponse) {
		dataLayer.push({ ecommerce: null });
		dataLayer.push({
			event: 'add_to_wishlist',
			ecommerce: {
				value: addToWishlistResponse.Price.Price,
				currency: 'GBP',
				items: [{
					item_id: addToWishlistResponse.Name,
					item_name: addToWishlistResponse.DisplayName,
					price: addToWishlistResponse.Price.Price,
					quantity: addToWishlistResponse.Quantity
				}]
			}
		});
	}

};

tracking.init();	